<template>

  <v-dialog v-model="showDialog" max-width="300" v-if="data.selectedPrize" class="semi-transparent-5-bg">
        <!-- Alert -->
        <Alert :atype="alertType" :message="alertMessage" :visibility="visibility" />

        <v-card class="semi-transparent-9-bg">

            <v-card-title style="border-bottom: 5px solid #3944bb">

                <img src="//assets.office4u.xyz/photos/BO-Demo/prize.svg" style="float: left; width: 15%; max-width: 50px; margin-right: 15px;"/>

                <div class="withdraw-form-title">

                    <span>{{ $t( 'history.bonus').toUpperCase() }}</span>

                </div>

            </v-card-title>

            <v-card-text class="v-card__text">

                <v-form ref="form" v-model="valid" lazy-validation>

                    <v-layout wrap>

                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'reusable.product' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                 <v-select :items="productList" v-model="data.selectedProduct" item-value="id" :rules="productRules">

                                    <template slot="selection" slot-scope="data">

                                        <img :src="data.item.logo" width="45px;" style="margin-right: 5px;"/>

                                        {{ data.item.name }}

                                    </template>

                                    <template slot="item" slot-scope="data">

                                        <img :src="data.item.logo" width="45px;" style="margin-right: 5px;"/>

                                        {{ data.item.name }}

                                    </template>

                                </v-select>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Amount -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'miniGame.amount' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                                  <v-text-field :value="data.selectedPrize.amount" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Selected Prize ID -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'miniGame.id' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                               <v-text-field :value="data.selectedPrize.id" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Selected Prize Game Name -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'miniGame.game' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                               <v-text-field :value="data.selectedPrize.gameName" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                        <div style="margin-bottom: 1em;"></div>

                        <!-- Selected Prize Game Name -->
                        <v-layout row class="margin-5-top-bottom">

                            <v-flex xs4>

                                <v-subheader class="inputlabel">{{ $t( 'miniGame.prizeName' ) }}</v-subheader>

                            </v-flex>

                            <v-flex xs8 class="margin-16-right">

                               <v-text-field :value="data.selectedPrize.name" disabled></v-text-field>

                            </v-flex>

                        </v-layout>

                    </v-layout>

                </v-form>

            </v-card-text>

             <v-card-actions class="v-card__actions font-size">

                <v-btn color="blue darken-1" :disabled="!valid" flat @click.prevent="save" small>{{ $t( 'shared.save' ) }}</v-btn>

                <v-btn color="blue darken-1" flat @click="showDialog = false" small>{{ $t( 'reusable.close' ) }}</v-btn>

                <v-spacer></v-spacer>

            </v-card-actions>

        </v-card>

    </v-dialog>

</template>

<style scoped>
    hr {
        margin-top: 0px !important;
        margin-bottom: 0px !important;
    }

    div.v-list__tile {
        height: 55px !important;
    }

    .v-list__tile__sub-title {
        font-size: 12px;
    }

    .v-list__tile__title {
        font-size: 16px;
    }
</style>

<script>
import Api from "@/api";
import Alert from "@/components/Reusable/Alert.vue";

export default {
    props: ['dialog', 'selectedPrize'],
    data() {
        return {
            valid: true,
            showDialog: this.dialog,
            productList: [],
            data: {
                selectedPrize: null,
                selectedProduct: null,
            },
            alertType: "error",
            alertMessage: "",
            visibility: false,
        };
    },
    components: {
        Alert
    },
    mounted() {

        this.getProducts();

    },
    methods: {
        async save() {

             if (this.$refs.form.validate()) {

                let param = {
                    access_token: this.$store.getters.user_token,
                    product_to: this.data.selectedProduct,
                    prize_log_id: this.data.selectedPrize.id,
                    bonus_amount: this.data.selectedPrize.amount
                };

                let res = await Api.postBonus(param);

                if (res && 'success' in res && res.success === true) {

                    this.showDialog = !this.showDialog;

                    this.$emit("save-dialog", {
                        dialog: this.showDialog,
                        message: res.message
                    });

                } else {

                    if(res.message == "token invalid") {

                        this.$store.dispatch('logout', res.data);

                        this.$router.push({name: 'login'})

                    } else if(res.message == "Ticket Detail Invalid") {

                        let message = res.message;

                        for (var oprop in res.data) {

                            message += '<br>' + res.data[oprop];

                        }

                        this.showValidateMessage(message);

                    } else if(res.message == "Submit Ticket Fail") {

                        this.showValidateMessage(res.data);

                    } else {

                         this.showValidateMessage(res.message);

                    }

                }

            } else {

                this.showValidateMessage(this.$t( 'deposit.not_completed_form' ));
            }
        },
        showValidateMessage(message) {

            this.visibility = true;

            this.alertMessage = message;

            let currentInstance = this;

            setTimeout(function() {

                currentInstance.visibility = false;

                currentInstance.alertMessage = "";

            } , 2000);

        },
        async getProducts() {

            let res = await Api.getProductsMember({
                access_token: this.$store.getters.user_token
            });

            if (res && 'success' in res && res.success === true) {

                let products = res.data;

                let currentInstance = this;

                this.productList = products.map(function(product){

                    if(product.id == 1) {

                        product.logo = currentInstance.getImgUrl('wallet');

                    }

                    if(product.id != 1 && product.logo == '') {

                        product.logo = currentInstance.getImgUrl('coming-soon');

                    }

                    return product;

                });

            } else {

                this.visibility = true;

                this.alertMessage = res.message;

                if(res.message == "token invalid") {

                    this.$store.dispatch('logout', res.data);

                    this.$router.push({name: 'login'})

                }

            }

        },
        getImgUrl(name) {

            let images = require.context('@/assets/', false, /\.png$/);

            return images('./' + name + ".png");

        }
    },
    computed: {
        productRules() {
            return [
                    v => !!v || this.$t( 'withdraw.product_validation_rule' )
            ]
        }
    },
    watch: {
        dialog(newValue) {
            return this.showDialog = newValue;
        },
        showDialog: function(newValue) {
            if (newValue == false) {
                this.$emit('close-dialog')
            }
        },
        selectedPrize: function(newValue) {
            this.data.selectedPrize = newValue;
        },
        prizeLogAmount: function(newValue) {
            this.data.prizeLogAmount = newValue;
        }
    }
};
</script>